/** True only in the native app build (`VITE_NATIVE=true`). A build-time constant: native modules load through `await import()` behind it. */
export function isNative(): boolean {
  return import.meta.env.VITE_NATIVE === 'true';
}
